import {vpost} from "@/util/post";

export const survey = {
    listQuestionnaire() {
        return vpost("/survey/listQuestionnaire");
    },

    getQuestionnaireDetail(id) {
        return vpost("/survey/getQuestionnaireDetail?id=" + id);
    },


    createQuestionnaire(dto) {
        return vpost("/survey/createQuestionnaire", dto);
    },

    updateQuestionnaire(dto) {
        return vpost("/survey/updateQuestionnaire", dto);
    },

    deleteQuestionnaire(id) {
        return vpost("/survey/deleteQuestionnaire?id=" + id);
    },

}
